<div class="banner">
  <div class="container">
    <div class="row justify-content-end">
      <div class="header_right">
        <ul>
          <li data-aos="fade-right">
            <a
              href="registration/user?reg={{ referralId }}"
              target="_blank"
              rel="noopener"
              class="go"
              ><i class="fas fa-edit fa-1x"></i> Signup</a
            >
          </li>

          <!-- <li data-aos="fade-left"><a href="https://gofounders.net/"><i class="fas fa-sign-in-alt fa-2x"></i> Signin</a></li> -->
        </ul>
      </div>
    </div>

    <div class="row justify-content-end">
      <div class="left_banner_box">
        <h1 data-aos="fade-right">
          <span class="d-block text-capitalize">You are invited by:</span>
          {{ userName }}
        </h1>
      </div>

      <div class="right_banner_text text-center" data-aos="zoom-in">
        <h1>EXPERIENCE A TRUE MARKETER'S MIRACLE</h1>

        <p>
          Do you believe in the power of the internet and the concept of working
          from home?
        </p>
      </div>
    </div>
  </div>
</div>

<!--BANNER PART CLOSED-->

<!--SECTION TWO PART OPEN-->

<div class="sec_two">
  <div class="container">
    <div class="row">
      <div class="col-lg-5">
        <div class="sec_two_left_box" data-aos="fade-right">
          <h2>
            Believing that you have understood Mr. Ash Mufareh's plan and
            strategy which he has framed to help you consistently earn more.
          </h2>

          <p>
            Global economic conditions have left millions of unhappy people in
            unrewarding careers. Job stability is no longer guaranteed and
            people are working longer hours for less pay.
          </p>

          <!-- 
                  <a href="https://www.gofounders.net/users/registration/48149" class="btn11">



     <span>BECOME A FOUNDER NOW</span>



  <div class="transition"></div>



</a> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!--SECTION TWO PART CLOSED-->

<!--SECTION THREE PART OPEN-->

<div class="sec_three">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="first_video" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation18/images/video_one_image.jpg"
            class="img-fluid"
            alt="image"
          />

          <div class="play_button">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal1"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation18/images/play_button.jpg"
                class="img-fluid"
                alt="image"
            /></a>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="sec_three_right_box" data-aos="fade-left">
          <h1>Watch through this videos</h1>

          <p>This modern marketing concept aims at providing you</p>

          <ul class="list-unstyled ml-0 pl-0">
            <li>An Upgraded Marketing Automation</li>

            <li>Guaranteed Web Traffic</li>

            <li>Instant Earnings</li>
          </ul>

          <a
            href="registration/user?reg={{ referralId }}"
            target="_blank"
            rel="noopener"
            class="btn11 f-btn"
          >
            <span>BECOME A FOUNDER NOW</span>

            <div class="transition"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!--SECTION THREE PART CLOSED-->

<section class="new">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="sec_four_left_box new-box">
          <h1 data-aos="fade-up">NOW YOU HAVE TWO OPTIONS:</h1>

          <ul class="ml-0 pl-0">
            <li data-aos="fade-right">
              You can wait for the business to launch. Select a business package
              for $25 and purchase a founders position for $997. However, this
              'founder' position depends on the availability of the spots.
            </li>

            <li data-aos="fade-right">
              Secure a Founders position NOW for a 90% discounted one-time fee
              of $97 to join the 1% at the TOP before the entire market joins.
              HIGHLY RECOMMENDED!
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="first_video" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation18/images/video_two_image.jpg"
            class="img-fluid"
            alt="image"
          />

          <div class="play_button">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal2"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation18/images/play_button.jpg"
                class="img-fluid"
                alt="image"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="sec_four">
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <div class="sec_four_left_box">
          <div class="world_box" data-aos="fade-left">
            <h1>The second option really changed my world.</h1>

            <P
              >I am surprised with the results that I have got in this short
              span. Dreams really started to turn into reality.</P
            >

            <P
              >This is the best and most honest concept that I have gone through
              in my entire life and that too with guaranteed results. Join the
              team now and I guarantee great results that you have never seen
              before. You would be very pleased.</P
            >
          </div>

          <a
            href="registration/user?reg={{ referralId }}"
            target="_blank"
            rel="noopener"
            class="btn11 f-btn"
            data-aos="zoom-in"
          >
            <span>BECOME A FOUNDER NOW</span>

            <div class="transition"></div>
          </a>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="sec_four_right_box">
          <h1 data-aos="fade-down">
            WHY GIVE AN EXCUSE WHEN YOU CAN BE THE CHANGE
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sec_five">
  <div class="sec_five_main">
    <div class="container">
      <div class="row justify-content-end no-gutters">
        <div class="sec_five_left_image">
          <img
            src="{{ myLinksS3URL }}frontend/presentation18/images/man_image.png"
            class="img-fluid"
            alt="image"
          />
        </div>

        <div class="col-lg-8">
          <div class="row no-gutters">
            <div class="col-lg-6">
              <div class="sec_five_left" data-aos="fade-right">
                <p>
                  Our Breakthrough platform provides you with long-term residual
                  payments, which can continue for life. We learned very early
                  on, that taking people to the top is more fulfilling to us,
                  than arriving alone. The art of "making money while helping
                  others profit on the web" is our field
                </p>

                <p>
                  In our Global Team, there are real people who want to give you
                  an honest hand to help you succeed. It's been said that every
                  person has only two real opportunities throughout their life,
                  if you passed one, this could be your last chance.
                </p>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="sec_five_right">
                <h1>The second option really changed my world.</h1>

                <div class="step_box">
                  <h4>2</h4>

                  <h6>steps</h6>
                </div>

                <div class="step_main_box">
                  <div class="step_box_left" data-aos="flip-up">
                    Fill up the form that requires the basic information
                  </div>

                  <div class="step_box_left" data-aos="flip-down">
                    Fill up the form that requires the basic information
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify-content-end">
      <div class="col-lg-7">
        <h5 data-aos="fade-left">
          Welcome To The <span>O-Founders</span> <strong>Family</strong>
        </h5>
      </div>
    </div>
  </div>
</div>

<div class="sec_six">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="sec_six_left_box" data-aos="fade-right">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation18/images/video_third.jpg"
            class="img-fluid"
            alt="image"
          />

          <div class="play_button">
            <a
              href="#"
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#myModal3"
              ><img
                src="{{
                  myLinksS3URL
                }}frontend/presentation18/images/play_button.jpg"
                class="img-fluid"
                alt="image"
            /></a>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="sec_six_right_box">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation18/images/arrow_main.png"
            class="img-fluid"
            alt="image"
            data-aos="zoom-in"
          />

          <h1 data-aos="fade-right">Watch This Video</h1>

          <h2 data-aos="fade-left">BECOME A FOUNDER NOW</h2>

          <p data-aos="fade-up">
            How would your life be in the next 10 years if money was no longer
            an issue? Our revolutionary system is like flipping a success switch
            that can last your whole lifetime. Mr. Ash Mufareh has a very
            extensive network of loyal resources that will help to make the
            plans a big success.
          </p>

          <p data-aos="fade-up">
            This is not hype or fluff! You have to see it for yourself. After
            our most recent webinar, We are totally convinced that we will all
            succeed to our wildest dreams with this business.
          </p>

          <p data-aos="fade-up">
            CHEERS TO THE. . . Greatest Opportunity so far, in the history of
            Internet Marketing!
          </p>

          <a
            href="registration/user?reg={{ referralId }}"
            target="_blank"
            rel="noopener"
            class="btn12 f-btn"
            data-aos="zoom-in"
          >
            <span>BECOME A FOUNDER NOW</span>

            <div class="transition"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-7">
        <div class="footer_left_box">
          FOR A LITTLE WHILE YET, FOUNDER POSITIONS STILL AVAILABLE!
        </div>
      </div>

      <div class="col-lg-5">
        <div class="footer_right_box">Copyright O-Founders 2022</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal 1 -->

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<!-- Modal 2 -->

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          id="second_video_pause"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<!-- Modal 3 -->

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          id="third_video_pause"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div class="country_popup_wrapper"></div>
